<template>
  <div class="hvh-flex wrap">
    <div class="col-12 col-md-6 col-xl-12 p-0 hvh-flex wrap">
      <ITMCustomerSearch class="col-12 col-xl-4" v-model="value.facilityName" :items="customers" :filterFnc="customerFilterFnc" text="Company/Facility" prop="facilityName" @input="$emit('customer-selected', $event)" />
      <!-- <v-text-field class="" label="" :value="value.companyFacility" :rules="requiredRules" @input="changeProperty('companyFacility', $event)" /> -->
      <v-text-field class="col-12 col-xl-4" label="Address" :value="value.addressLine1" :rules="requiredRules" @input="changeProperty('addressLine1', $event)" />
      <v-text-field class="col-12 col-xl-4" label="City/State/ZIP" v-model="cityStateZip" :rules="cityStateZipRules" />
    </div>
    <div class="col-12 col-md-6 col-xl-12 p-0 hvh-flex wrap">
      <v-text-field class="col-12 col-xl-4" label="Contact" :value="value.contactPoc" :rules="requiredRules" @input="changeProperty('contactPoc', $event)" />
      <v-text-field class="col-12 col-xl-4" label="Email" :value="value.email" :rules="requiredRules" @input="changeProperty('email', $event)" />
      <v-text-field class="col-12 col-xl-4" label="Phone" :value="value.contactNumber" :rules="requiredRules" @input="changeProperty('contactNumber', $event)" />
    </div>
  </div>
</template>

<script>
import { propToBool } from '../../libraries/common';
import ITMCustomerSearch from './ITMCustomerSearch.vue';
export default {
  components: { ITMCustomerSearch },
  props: ['value', 'required', 'customers', 'customerFilterFnc'],
  computed: {
    cityStateZip: {
      get() {
        return [this.value.city, this.value.state, this.value.zip]
          .map(f => f || '')
          .join('/')
          .replace(/\/+$/, '');
      },
      set(value) {
        var [city, state, zip] = (value || '').split('/');
        this.$emit('input', { ...this.value, city, state, zip });
      },
    },
    requiredRules() {
      return propToBool(this.required) ? [v => !!v || v === false || 'Field is required'] : [];
    },
    cityStateZipRules() {
      return [
        ...this.requiredRules,
        v => (v || '').split('/').length < 4 || 'You cannot have more then 2 slashes',
      ];
    },
  },
  methods: {
    changeProperty(prop, value) {
      this.$emit('input', { ...this.value, [prop]: value });
    },
  },
}
</script>